// MAISON MEGA MENU

function initMaisonMenu() {

  const drawer = document.querySelector(".menu-drawer");
  if (!drawer) return;

  /* prevent double initialization (Shopify section reloads) */
  if (drawer.dataset.maisonInitialized) return;
  drawer.dataset.maisonInitialized = true;

  const mega = drawer.querySelector(".maison-megamenu");

  const level1Buttons = drawer.querySelectorAll(".maison-level1-item");
  const level2Buttons = drawer.querySelectorAll(".maison-level2-item");

  const level2Panels = drawer.querySelectorAll(".maison-level2-panel");
  const level3Panels = drawer.querySelectorAll(".maison-level3-panel");

  const backButton = drawer.querySelector(".maison-back");
  const backTitle = drawer.querySelector(".maison-back-title");

  const closeButtons = drawer.querySelectorAll(".menu-drawer__close-button");

  const atelierdrawer = document.querySelector("header-drawer");

  let level = 0;
  let activeLevel2 = null;

  let parentLevel1 = "";
  let parentLevel2 = "";

  function isMobile() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function updateBackButton() {

    if (!backButton || !backTitle) return;

    if (level === 0) {
      backButton.classList.remove("is-visible");
      backTitle.textContent = "";
      return;
    }

    backButton.classList.add("is-visible");

    if (level === 1) {
      backTitle.textContent = parentLevel1;
    }

    if (level === 2) {
      backTitle.textContent = parentLevel1 + " / " + parentLevel2;
    }

  }

  function setLevel(newLevel) {

    level = newLevel;

    mega.classList.toggle("megamenu-level2-open", level >= 1);
    mega.classList.toggle("megamenu-level3-open", level >= 2);

    if (isMobile()) {
      mega.classList.toggle("is-level2-active", level >= 1);
      mega.classList.toggle("is-level3-active", level >= 2);
    }

    updateBackButton();

  }

  function setActive(button) {

    const list = button.closest("ul");
    if (!list) return;

    list.querySelectorAll(".is-active").forEach(el => {
      el.classList.remove("is-active");
    });

    const li = button.closest("li");
    if (li) li.classList.add("is-active");

  }

  function clearLevel2Active() {
    drawer.querySelectorAll(".maison-submenu-list .is-active").forEach(el => {
      el.classList.remove("is-active");
    });
  }

  function clearLevel3Active() {
    drawer.querySelectorAll(".maison-level3-list .is-active").forEach(el => {
      el.classList.remove("is-active");
    });
  }

  function clearAllActive() {
    drawer.querySelectorAll(".is-active").forEach(el => {
      el.classList.remove("is-active");
    });
  }

  /* ---------------- PANEL SWITCH ---------------- */

  function switchPanel(panels, panel) {

    panels.forEach(p => p.classList.remove("active"));

    requestAnimationFrame(() => {
      panel.classList.add("active");
    });

  }

  /* ---------------- LEVEL 2 ---------------- */

  function openLevel2(handle, title) {

    clearLevel2Active();
    clearLevel3Active();

    const panel = drawer.querySelector(`.maison-level2-panel[data-panel="${handle}"]`);
    if (!panel) return;

    activeLevel2 = handle;

    parentLevel1 = title;
    parentLevel2 = "";

    level3Panels.forEach(p => p.classList.remove("active"));

    switchPanel(level2Panels, panel);

    setLevel(1);

  }

  /* ---------------- LEVEL 3 ---------------- */

  function openLevel3(handle, title) {

    clearLevel3Active();

    const panel = drawer.querySelector(`.maison-level3-panel[data-panel="${handle}"]`);
    if (!panel) return;

    parentLevel2 = title;

    switchPanel(level3Panels, panel);

    setLevel(2);

  }

  /* ---------------- BACK ---------------- */

  function goBack() {

    if (level === 2) {

      clearLevel3Active();

      setLevel(1);
      parentLevel2 = "";
      return;

    }

    if (level === 1) {

      clearLevel2Active();
      clearLevel3Active();

      setLevel(0);

      level2Panels.forEach(p => p.classList.remove("active"));

      activeLevel2 = null;
      parentLevel1 = "";

      return;

    }

  }

  /* ---------------- RESET ---------------- */

  function resetMenu() {

    level = 0;
    activeLevel2 = null;

    parentLevel1 = "";
    parentLevel2 = "";

    clearAllActive();

    level2Panels.forEach(p => p.classList.remove("active"));
    level3Panels.forEach(p => p.classList.remove("active"));

    mega.classList.remove(
      "is-level2-active",
      "is-level3-active",
      "megamenu-level2-open",
      "megamenu-level3-open"
    );

    updateBackButton();

  }

  /* ---------------- LEVEL 1 CLICK ---------------- */

  level1Buttons.forEach(btn => {

    btn.addEventListener("click", () => {

      const handle = btn.dataset.menu;
      const title = btn.textContent.trim();

      setActive(btn);

      if (!isMobile() && handle === activeLevel2) {
        resetMenu();
        return;
      }

      openLevel2(handle, title);

    });

  });

  /* ---------------- LEVEL 2 CLICK ---------------- */

  level2Buttons.forEach(btn => {

    btn.addEventListener("click", () => {

      const handle = btn.dataset.level3;
      const title = btn.textContent.trim();

      setActive(btn);

      openLevel3(handle, title);

    });

  });

  /* ---------------- BACK BUTTON ---------------- */

  if (backButton) {
    backButton.addEventListener("click", goBack);
  }

  /* ---------------- CLOSE BUTTON ---------------- */

  closeButtons.forEach(btn => {
    btn.addEventListener("click", resetMenu);
  });

  /* ---------------- RESIZE SAFETY ---------------- */

  window.addEventListener("resize", () => {

    if (!isMobile()) {
      mega.classList.remove("is-level2-active", "is-level3-active");
    }

  });

  /* ---------------- DRAWER TOGGLE ---------------- */

  const drawerDetails = drawer.closest("details");

  if (drawerDetails) {

    drawerDetails.addEventListener("toggle", () => {

      if (!drawerDetails.open) {
        resetMenu();
      }

      document.body.classList.toggle(
        "maison-drawer-open",
        drawerDetails.open
      );

    });

  }

  /* geoip drawer listener */

  const geoipLink = drawer.querySelector('.maison-geoip-trigger');
  if (geoipLink) {
    geoipLink.addEventListener('click', () => {
      if (drawerDetails) {
        atelierdrawer.close();
        resetMenu();
      }
      document.querySelector('#maison-geoip-popup')?.showDialog?.();
    });
  }

}

function initScrollHeader() {
  const header = document.querySelector('.header');
  const filters = document.querySelector('.maison-mini-menu');
  const facets = document.querySelector('.maison-facets-wrapper') ;

  if (!header) return;

  const isDesktop = window.matchMedia('(min-width: 750px)').matches;

  let lastScroll = 0;
  let ticking = false;
  let lastDirection = null;
  let scrollStart = 0;

  let upAccum = 0;
  const UP_THRESHOLD = 500;

  const threshold = 50;
  const secondThreshold = 150;
  const topThreshold = 10;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {

        const current = window.scrollY;
        const diff = current - lastScroll;

        /* -------- FIXED DIRECTION DETECTION -------- */
        let direction = lastDirection;

        if (diff > 0) {
          // any downward movement reacts immediately
          direction = 'down';
          upAccum = 0;            // reset the upward counter
        } else if (diff < 0) {
          upAccum += -diff;       // build up how far we've scrolled up
          if (upAccum >= UP_THRESHOLD) {
          direction = 'up';
          // optional: don't reset here, so it stays 'up' while scrolling up
        }
        // below threshold → keep lastDirection, do nothing
        }

        /* ================= DESKTOP ================= */

        if (isDesktop) {

          if (Math.abs(diff) < 2) {
            lastScroll = current;
            ticking = false;
            return;
          }

          if (direction === 'down' && current > secondThreshold) {
            header.classList.add('is-hidden');
            filters?.classList.add('is-hidden');
            facets?.classList.add('is-hidden');
            document.querySelectorAll('[id^="Sorting-"][open]')
             .forEach(d => d.removeAttribute('open'));
            document.querySelectorAll('[id^="Facet-Details-"][open]')
             .forEach(d => d.removeAttribute('open')); 
          }

          if (direction === 'up') {
            header.classList.remove('is-hidden');
            filters?.classList.remove('is-hidden');
            facets?.classList.remove('is-hidden');
          }

          if (current <= secondThreshold) {
            header.classList.remove('is-hidden');
            filters?.classList.remove('is-hidden');
            facets?.classList.remove('is-hidden');
          }
        }

        /* ================= MOBILE ================= */

        else {

          /* -------- DIRECTION CHANGE -------- */
          if (direction !== lastDirection) {
            scrollStart = current;

            if (direction === 'up') {
              // show everything immediately
              header.classList.remove('is-hidden');
              filters?.classList.remove('is-hidden');
              facets?.classList.remove('is-hidden');

              document.body.classList.remove('scroll-hidden');
              document.body.classList.remove('header-hidden');
              document.body.classList.remove('stack-hidden');

              // keep collapsed if not at top
              if (current > topThreshold) {
                document.body.classList.add('not-at-top');
              }
            }

            if (direction === 'down') {
              document.body.classList.add('scroll-hidden');
            }
          }

          /* -------- SCROLL DOWN -------- */
          if (direction === 'down') {

            const distance = current - scrollStart;

            // 1. hide header first
            if (distance > threshold) {
              header.classList.add('is-hidden');
              document.body.classList.add('header-hidden');

              // 2. THEN collapse mini menu
              document.body.classList.add('not-at-top');
            }

            // 3. THEN hide stack
            if (distance > secondThreshold) {
              filters?.classList.add('is-hidden');
              facets?.classList.add('is-hidden');
              document.querySelectorAll('[id^="Sorting-"][open]')
             .forEach(d => d.removeAttribute('open'));
             document.querySelectorAll('[id^="Facet-Details-"][open]')
             .forEach(d => d.removeAttribute('open')); 
              document.body.classList.add('stack-hidden');
            }
          }

          /* -------- SCROLL UP -------- */
          if (direction === 'up') {

            header.classList.remove('is-hidden');
            filters?.classList.remove('is-hidden');
            facets?.classList.remove('is-hidden');

            document.body.classList.remove('scroll-hidden');
            document.body.classList.remove('header-hidden');
            document.body.classList.remove('stack-hidden');

            // stay collapsed unless at top
            if (current > topThreshold) {
              document.body.classList.add('not-at-top');
            }
          }

          /* -------- TOP RESET -------- */
          if (current <= topThreshold) {
            header.classList.remove('is-hidden');
            filters?.classList.remove('is-hidden');
            facets?.classList.remove('is-hidden');

            document.body.classList.remove('scroll-hidden');
            document.body.classList.remove('header-hidden');
            document.body.classList.remove('stack-hidden');
            document.body.classList.remove('not-at-top');

            scrollStart = current;
          }
        }

        /* -------- STATE UPDATE -------- */
        if (direction) {
          lastDirection = direction;
        }

        lastScroll = current;
        ticking = false;

      });

      ticking = true;
    }
  });
}
/* initialize */

document.addEventListener("DOMContentLoaded", () => {
  initMaisonMenu();
  initScrollHeader();
});

document.addEventListener("shopify:section:load", () => {
  initMaisonMenu();
  initScrollHeader();
});

